import React, { useContext, useEffect, useState } from "react";
import FormInput from "../../components/FormInputs/FormInput";
import NavButton from "../../components/NavButton/index";
import ContentHeader from "../../components/ContentHeader/index";
import MsmContext, { Actions } from "../../reducers/Context";
import useForm, { FormContext } from "react-hook-form";
import { API, useDataApi } from "../../components/API";
import LoaderAnim from "../../components/LoaderAnim";
import { getSmartlookData, setStorageData } from "../../utils";

const EmailForm = (props) => {
  const { data, isLoading, doFetch } = useDataApi("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [userData, setUserData] = useState();
  const { dispatch, state } = useContext(MsmContext);
  const hookForm = useForm();

  // Effect for API call
  useEffect(() => {
    //console.log("data", data);
    if (data) {
      if (!state.teamMemberMode && data.response.EmailInUse) {
        //console.log("email in use!");
        setEmailErrorMessage("Email address in use, please log in and restart the sign up process to use this email");
        hookForm.setError("email", emailErrorMessage);
      } else {
        // setStorageData("user", userData);
        dispatch({
          type: Actions.UPDATED_USER_DETAILS,
          payload: { user: userData },
        });
        doFetch(
          API.SET_SIGNUP_LEAD,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            },
            body: `jsonData=${JSON.stringify({
              user: userData,
              ...getSmartlookData(),
            })}`,
          },
          { ignoreCache: true }
        );
      }
    }
  }, [data]);

  const onSubmit = async (_data) => {
    //console.log("dispatch", _data);
    doFetch(`${API.CHECK_IF_EMAIL_IN_USE}?email=${_data.email}`, {
      ignoreCache: true,
      minimumWait: 500,
    });
    setUserData(_data);
  };

  return (
    <>
      <div className="afs-msm-stage-content add-all-padding">
        {isLoading ? (
          <LoaderAnim />
        ) : (
          <>
            <ContentHeader icon="user157" iconFill="teal" iconSize="25" text="Please enter your details" />
            <FormContext {...hookForm}>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  hookForm.handleSubmit(onSubmit);
                }}
              >
                <FormInput
                  type="email"
                  name="email"
                  label="What's your email address?"
                  errorText={emailErrorMessage || "A valid email address is required"}
                  validation={{
                    required: true,
                  }}
                  defaultValue={(userData && userData.email) || (state.user && state.user.email)}
                />
                <FormInput
                  type="text"
                  name="name"
                  label="What's your full name?"
                  errorText="Your name is required"
                  validation={{ required: true }}
                  defaultValue={(userData && userData.name) || (state.user && state.user.name)}
                />
                {!state.teamMemberMode && (
                  <FormInput
                    name="password"
                    type="password"
                    label="Please enter a secure, memorable password"
                    errorText="A password of 8 or more characters is required"
                    validation={{ required: !state.teamMemberMode, minLength: 8 }}
                    defaultValue={(userData && userData.password) || (state.user && state.user.password)}
                    autocorrect="off"
                    autocapitalize="none"
                  />
                )}
                <button type="submit" style={{ display: "none" }}>
                  HIDDEN
                </button>
              </form>
            </FormContext>
          </>
        )}
      </div>
      <div className="afs-msm-stage-action-buttons">
        <NavButton text="BACK" actionType={Actions.PREV_STAGE} />
        <NavButton text="CONTINUE" type="submit" onClick={hookForm.handleSubmit(onSubmit)} />
      </div>
    </>
  );
};

export default {
  id: "email-form",
  title: "Sign up to TeamStats",
  subtitles: ["We take privacy seriously.", "All personal data is stored securely."],
  imageUrl: "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-4.jpg",
  component: EmailForm,
  buttons: [
    {
      text: "BACK",
      type: Actions.PREV_STAGE,
    },
  ],
};
